import React, {useState} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";
import {EditIcon} from "../common/icons";
import COLOR_THEMES from "../../colorThemes";
import TextInput from "../ui/textInput";
import {setManualTax} from "../../actions/shoppingCartFunctions";
import {getPriceWithCurrency} from "../../misc/helpers";

const MAX_TAX = 999999;


const ShoppingCartTaxInput = (props) => {

  const {setManualTax, activeTheme, fabricatorSettings, sureTax, taxTotal, manualTaxEntered} = props;

  const [priceEditing, setPriceEditing] = useState(false);

  const togglePriceEditing = () => setPriceEditing(!priceEditing);

  // if (selectionFeatureInfo && selectionFeatureInfo.dbFeature.id && document.kvConfig.isBackend) {
  //   return <FeatureInfoPriceInput/>
  // }

  const handlePriceOnChange = (newAmount) => {
    setManualTax(newAmount > MAX_TAX ? MAX_TAX : newAmount);
  }

  return (
    <div className="product-info__edit">
      <TextInput className={"ui-input ui-input--new product-info__edit-input"
        + (priceEditing ? " product-info__edit-input--visible" : "")}
                 numberInput={true}
                 autoComplete={"off"}
                 id="product-info-input"
                 onChange={handlePriceOnChange}
                 onBlur={togglePriceEditing}
                 onRealChange={handlePriceOnChange}
                 value={sureTax}/>
      {priceEditing ? null : <p className="dcart-column__value">
        {getPriceWithCurrency(fabricatorSettings, manualTaxEntered ? sureTax : taxTotal)}
      </p>}
      <label htmlFor="product-info-input" className="product-info__edit-icon" onClick={togglePriceEditing}>
        <EditIcon color={COLOR_THEMES[activeTheme].active}/>
      </label>
    </div>
  )
};

ShoppingCartTaxInput.propTypes = {
  onBlur: PropTypes.func,
  taxTotal: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

const mapStateToProps = (store) => {
  const {activeTheme} = store.serverState;
  const {sureTax, manualTaxEntered} = store.cartState;
  return {
    fabricatorSettings: store.fabricatorState.settings,
    sureTax,
    manualTaxEntered,
    activeTheme,
  };
};

const mapDispatchToProps = {
  setManualTax
}

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(ShoppingCartTaxInput)
);
